/* v17 · Menú desplegable y buscador (sections/ord17-nav.liquid). Referencia: cabecera de apple.com (14-oct).
   El panel crece desde la cabecera de Horizon: al pasar el ratón por un enlace de colección enseña sus productos,
   y la lupa abre aquí el buscador (con resultados en vivo de /search/suggest.json). Si este JS falla, la lupa
   sigue abriendo el buscador de Horizon. */
(function () {
  var D = document, H = D.documentElement;
  var desk = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function path(u) { try { return new URL(u, location.href).pathname.replace(/\/$/, '') || '/'; } catch (e) { return u; } }
  // Lo escrito, en tinta; el resto, atenuado
  function mark(text, q) {
    var t = String(text || ''), i = q ? t.toLowerCase().indexOf(q.toLowerCase()) : -1;
    if (i < 0) return esc(t);
    return '<span class="o17n-dim">' + esc(t.slice(0, i)) + '</span><b>' + esc(t.slice(i, i + q.length)) + '</b><span class="o17n-dim">' + esc(t.slice(i + q.length)) + '</span>';
  }

  function init(root) {
    if (!root || root.dataset.o17nInit) return;
    root.dataset.o17nInit = '1';
    // Fuera del grupo de cabecera para que ningún contexto de apilamiento lo tape
    Array.prototype.forEach.call(D.querySelectorAll('body > [data-o17n]'), function (o) { if (o !== root) o.remove(); });
    D.body.appendChild(root);

    var panel = root.querySelector('.o17n-panel');
    var views = {}, cur = null, open = false, trigger = null, openT, closeT, hideT;
    Array.prototype.forEach.call(root.querySelectorAll('[data-o17n-view]'), function (v) {
      var k = v.dataset.o17nView;
      views[k === 'search' ? k : path(k)] = v;
    });
    var sView = views.search, input = sView.querySelector('.o17n-input'), form = sView.querySelector('form');
    var res = sView.querySelector('[data-o17n-res]');
    var ds = root.dataset;
    var cur$ = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    var money;
    try { money = new Intl.NumberFormat(H.lang || 'es', { style: 'currency', currency: cur$ }); } catch (e) { money = null; }

    function header() { return D.querySelector('header-component') || D.querySelector('#header-component') || D.querySelector('header'); }
    function loadImgs(v) {
      Array.prototype.forEach.call(v.querySelectorAll('img[data-src]'), function (im) { im.src = im.dataset.src; im.removeAttribute('data-src'); });
    }
    function fit() {
      if (!open || !cur) return;
      panel.style.height = (parseFloat(root.style.getPropertyValue('--o17n-top')) || 0) + cur.offsetHeight + 'px';
    }

    function show(key, from) {
      var v = views[key];
      if (!v) return;
      clearTimeout(closeT); clearTimeout(hideT);
      var h = header();
      root.style.setProperty('--o17n-top', Math.max(0, Math.round(h ? h.getBoundingClientRect().bottom : 56)) + 'px');
      if (trigger && trigger !== from) trigger.setAttribute('aria-expanded', 'false');
      trigger = from || null;
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      if (v === cur && open) return;
      loadImgs(v);
      var prev = cur;
      if (prev && prev !== v) {
        // El contenido anterior se va rápido y sin retraso, como en Apple
        prev.classList.add('is-leaving');
        prev.classList.remove('is-on');
        setTimeout(function () { if (prev !== cur) { prev.hidden = true; prev.classList.remove('is-leaving'); } }, 170);
      }
      cur = v;
      v.classList.remove('is-leaving');
      v.hidden = false;
      void v.offsetHeight;
      v.classList.add('is-on');
      open = true;
      H.classList.add('o17n-open');
      if (key === 'search' && !desk.matches) H.classList.add('o17n-lock');
      root.classList.add('is-open');
      fit();
    }

    function close() {
      if (!open) return;
      clearTimeout(openT);
      open = false;
      root.classList.remove('is-open');
      panel.style.height = '0px';
      var v = cur;
      if (v) v.classList.remove('is-on');
      H.classList.remove('o17n-lock');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (v === sView && D.activeElement && sView.contains(D.activeElement) && trigger) trigger.focus({ preventScroll: true });
      hideT = setTimeout(function () {
        if (open) return;
        if (v) v.hidden = true;
        cur = null;
        H.classList.remove('o17n-open');
      }, 280);
    }
    function closeSoon() { clearTimeout(openT); clearTimeout(closeT); closeT = setTimeout(close, 180); }

    // —— Menú: enlaces de colección de la cabecera (solo escritorio con ratón)
    function bindMenu() {
      Array.prototype.forEach.call(D.querySelectorAll('.menu-list__link'), function (a) {
        if (a.dataset.o17nBound) return;
        a.dataset.o17nBound = '1';
        var key = path(a.getAttribute('href') || '');
        var has = !!views[key];
        if (has) a.setAttribute('aria-expanded', 'false');
        a.addEventListener('mouseenter', function () {
          if (!desk.matches) return;
          clearTimeout(openT); clearTimeout(closeT);
          if (has) openT = setTimeout(function () { show(key, a); }, open && cur !== sView ? 0 : 120);
          else if (open && cur !== sView) closeSoon();
        });
        a.addEventListener('mouseleave', function () { clearTimeout(openT); });
        a.addEventListener('click', function () { if (open) close(); });
      });
      var h = header();
      if (h && !h.dataset.o17nBound) {
        h.dataset.o17nBound = '1';
        h.addEventListener('mouseleave', function (e) { if (open && cur !== sView && !root.contains(e.relatedTarget)) closeSoon(); });
        h.addEventListener('mouseenter', function () { if (cur !== sView) clearTimeout(closeT); });
      }
    }
    panel.addEventListener('mouseleave', function (e) {
      var h = header();
      if (open && cur !== sView && !(h && h.contains(e.relatedTarget))) closeSoon();
    });
    panel.addEventListener('mouseenter', function () { clearTimeout(closeT); });
    bindMenu();

    // Vista previa grande: cambia al producto que tiene el ratón o el foco
    function preview(a) {
      var view = a.closest('.o17n-view'), card = view && view.querySelector('[data-o17n-card]');
      if (!card || a.classList.contains('is-cur')) return;
      Array.prototype.forEach.call(view.querySelectorAll('.o17n-prod.is-cur'), function (x) { x.classList.remove('is-cur'); });
      a.classList.add('is-cur');
      card.href = a.href;
      card.querySelector('.o17n-card__name').textContent = a.dataset.name || '';
      card.querySelector('.o17n-card__price').textContent = a.dataset.price || '';
      var im = card.querySelector('.o17n-card__img img');
      if (im && a.dataset.card) {
        im.style.opacity = '0';
        var next = new Image();
        next.onload = function () { if (a.classList.contains('is-cur')) { im.src = next.src; im.style.opacity = ''; } };
        next.src = a.dataset.card;
      }
    }
    root.addEventListener('mouseover', function (e) { var a = e.target.closest('.o17n-prod[data-card]'); if (a) preview(a); });
    root.addEventListener('focusin', function (e) { var a = e.target.closest('.o17n-prod[data-card]'); if (a) preview(a); });

    // Cerrar: cortina, «Cancelar», Esc y los enlaces del panel
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-o17n-close]')) { e.preventDefault(); close(); return; }
      if (e.target.closest('a[href]')) setTimeout(close, 0);
    });
    D.addEventListener('keydown', function (e) {
      if (!open) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (cur === sView && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) {
        var box = sView.classList.contains('has-q') ? res : sView.querySelector('[data-o17n-idle]');
        var items = Array.prototype.slice.call(box.querySelectorAll('a[href]'));
        if (!items.length) return;
        e.preventDefault();
        var i = items.indexOf(D.activeElement);
        if (e.key === 'ArrowDown') (i < items.length - 1 ? items[i + 1] : items[0]).focus();
        else if (i <= 0) input.focus(); else items[i - 1].focus();
      }
    });

    // —— Buscador: la lupa de Horizon abre el nuestro (fase de captura, antes que su on:click)
    function openSearch(btn) {
      clearTimeout(openT);
      show('search', btn);
      input.focus({ preventScroll: true });
      if (input.value) input.select();
    }
    window.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('search-button, [on\\:click*="search-modal"]');
      if (!b || root.contains(b)) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (open && cur === sView) close(); else openSearch(b.querySelector('button') || b);
    }, true);

    var t, ctrl, last = '';
    function rows(list, q) {
      return list.map(function (p, i) {
        var price = '';
        if (p.price != null && p.price !== '') {
          var n = parseFloat(p.price);
          price = money && !isNaN(n) ? money.format(n) : String(p.price);
        }
        var img = p.image || (p.featured_image && p.featured_image.url) || '';
        return '<li class="o17n-it" style="--i:' + (i + 1) + '"><a class="o17n-row" href="' + esc(p.url) + '">' +
          '<span class="o17n-thumb">' + (img ? '<img src="' + esc(img) + (img.indexOf('?') < 0 ? '?' : '&') + 'width=120" alt="" width="44" height="44">' : '') + '</span>' +
          '<span class="o17n-name">' + mark(p.title, q) + '</span>' +
          (price ? '<span class="o17n-row__p">' + esc(price) + '</span>' : '') + '</a></li>';
      }).join('');
    }
    function links(list, q, key) {
      return list.map(function (x, i) {
        return '<li class="o17n-it" style="--i:' + (i + 1) + '"><a class="o17n-ql" href="' + esc(x.url) + '"><svg viewBox="0 0 12 12" aria-hidden="true"><path d="M1 6h9M6.5 2.5 10 6l-3.5 3.5"/></svg><span>' + mark(x[key], q) + '</span></a></li>';
      }).join('');
    }
    function render(q, r) {
      var prods = r.products || [], qs = (r.queries || []).filter(function (x) { return x.text && x.text.toLowerCase() !== q.toLowerCase(); }), cols = r.collections || [];
      var all = (ds.search || '/search') + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
      var html = '';
      if (!prods.length && !qs.length && !cols.length) {
        html = '<p class="o17n-empty o17n-it">' + esc(ds.tNada) + ' «<b>' + esc(q) + '</b>».</p>';
      } else {
        if (prods.length) html += '<div class="o17n-col" style="--g:0"><p class="o17n-head o17n-it">' + esc(ds.tProductos) + '</p><ul class="o17n-list">' + rows(prods, q) + '</ul></div>';
        var side = '';
        if (qs.length) side += '<p class="o17n-head o17n-it">' + esc(ds.tSugerencias) + '</p><ul class="o17n-ql-list">' + links(qs.slice(0, 5), q, 'text') + '</ul>';
        if (cols.length) side += '<p class="o17n-head o17n-it" style="margin-top:22px!important">' + esc(ds.tColecciones) + '</p><ul class="o17n-ql-list">' + links(cols.slice(0, 3), q, 'title') + '</ul>';
        if (side) html += '<div class="o17n-col" style="--g:1">' + side + '</div>';
      }
      html += '<div class="o17n-foot o17n-it" style="--g:1"><a class="o17n-all" href="' + esc(all) + '">' + esc(ds.tTodos) + ' ›</a></div>';
      res.innerHTML = html;
      res.classList.remove('is-in');
      void res.offsetHeight;
      res.classList.add('is-in');
      fit();
    }
    function search() {
      var q = input.value.trim();
      sView.classList.toggle('has-q', !!q);
      clearTimeout(t);
      if (!q) { if (ctrl) ctrl.abort(); last = ''; res.innerHTML = ''; fit(); return; }
      if (q === last) return;
      t = setTimeout(function () {
        if (ctrl) ctrl.abort();
        ctrl = window.AbortController ? new AbortController() : null;
        var url = (ds.predict || '/search/suggest') + '.json?q=' + encodeURIComponent(q) +
          '&resources%5Btype%5D=product,query,collection&resources%5Blimit%5D=6&resources%5Blimit_scope%5D=each&resources%5Boptions%5D%5Bfields%5D=title,product_type,variants.title,vendor';
        fetch(url, { headers: { Accept: 'application/json' }, signal: ctrl ? ctrl.signal : undefined })
          .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
          .then(function (d) {
            if (input.value.trim() !== q) return;
            last = q;
            render(q, (d.resources && d.resources.results) || {});
          })
          .catch(function () {});
      }, 120);
    }
    input.addEventListener('input', search);
    form.addEventListener('reset', function () { setTimeout(function () { search(); input.focus(); }, 0); });
    form.addEventListener('submit', function (e) { if (!input.value.trim()) e.preventDefault(); });

    var rt;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { if (open) { if (cur !== sView && !desk.matches) close(); else fit(); } }, 120); });
  }

  D.querySelectorAll('[data-o17n]').forEach(init);
  D.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('[data-o17n]')); });
})();
